import * as React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Image } from "../../../assets/Types/Image.type";
import VideoButton from "../../Buttons/VideoButton/VideoButton";
import loadVideo from "../../../assets/util-scripts/load-video";
import { VideoProps } from "../../../assets/Types/VideoProps.type";
import styles from "./TestimonialVideo.module.scss";

const TestimonialVideo: React.FC<VideoProps> = ({
  videoId,
  videoBackgroundImage,
  builderImage = false,
}) => (
  <div
    data-testid="div:TestimonialVideo"
    className={
      videoId
        ? styles.testimonialVideoContainer
        : styles.testimonialImageContainer
    }
    onClick={videoId && (() => loadVideo(videoId))}
  >
    {builderImage ? (
      <img
        alt={videoBackgroundImage.altText || ""}
        data-testid="practitioner-image"
        src={videoBackgroundImage}
      />
    ) : (
      <GatsbyImage
        image={getImage((videoBackgroundImage as unknown as Image).localFile)}
        alt={videoBackgroundImage.altText || ""}
      />
    )}

    {videoId && (
      <VideoButton
        buttonColor={"primary--white-bg"}
        iconWhite={false}
        isClass={false}
        videoID={videoId}
      />
    )}
  </div>
);

export default TestimonialVideo;
